// This file will contain the tray and logic for the Care Network panel in the 3D map, reusing the MapFilters and FilterToggleButton components.
import React, { useState } from 'react';
import { Box, Typography, Button, Paper, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MapFilters from '../map/MapFilters';
import FilterToggleButton from '../../components/map/FilterToggleButton';

const CareNetworkTray: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [showFilters, setShowFilters] = useState(true);

  const handleApplyFilters = (filters: any) => {
    // TODO: Implement filter logic for 3D map
  };

  return (
    <Box className="care-network-tray">
      <Box className="care-network-tray-header">
        <Typography variant="h6" gutterBottom>My Care Network</Typography>
        <Typography variant="body2" color="text.secondary">
          View and manage your healthcare network facilities and providers
        </Typography>
        <IconButton size="small" onClick={onClose} className="care-network-close-btn">
          <CloseIcon />
        </IconButton>
      </Box>
      <Box className="care-network-tray-controls">
        <FilterToggleButton showFilters={showFilters} onToggle={() => setShowFilters(!showFilters)} />
        <Button variant="contained" size="small" sx={{ ml: 1 }}>Add Facility</Button>
      </Box>
      <Box className="care-network-tray-content">
        {showFilters && (
          <Paper className="care-network-filters">
            <MapFilters onApplyFilters={handleApplyFilters} />
          </Paper>
        )}
        {/* You can add a map or other content here if needed */}
      </Box>
    </Box>
  );
};

export default CareNetworkTray;
